<template lang="pug">
.customer-data-container(@click="expand = !expand")
  .customer-data
    .customer-phone
      span.material-symbols-outlined person
      span {{ data.phone }}

    .customer-name.capitalize(v-if="data.name") {{ cutValue(data.name) }}
    .customer-name(v-else) —

    .customer-email(v-if="data.email") {{ cutValue(data.email) }}
    .customer-email(v-else) —

    .customer-addresses {{ data.addresses ? data.addresses.length : 0 }} dir.

    .customer-status
      .tag(:style="data.active ? 'background:#5cb85c;color:#fff' : 'background:#d9534f;color:#fff'") {{ data.active ? 'Activo' : 'Inactivo' }}

    .customer-date {{ dateName(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-customer(v-if="expand" :dataOriginal="data" :fillData="true" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import mFilters from '@/mixins/filters'

export default {
  name: 'Customer',

  mixins: [mFilters],

  components: { shForm },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    cutValue (value) {
      if (!value) return ''
      const maxLength = 14
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    }
  }
}
</script>

<style lang="stylus">
.customer-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em
  justify-content space-between

.customer-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em
  padding 0 1rem

.customer-phone
  display flex
  align-items center
  gap 0.4em

.customer-phone .material-symbols-outlined
  font-size 1.3em
  color #888

.list-customer
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .customer-data
    flex-basis 100%
    column-gap 0
    row-gap 1em

  .customer-phone
    width 11em

  .customer-name
    width 12em

  .customer-email
    width 14em

  .customer-addresses
    width 5em
    text-align center

  .customer-status
    width 7em

  .customer-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/customer/Customer.vue